const down = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11%2018.586V3h2v15.586l6.293-6.293%201.414%201.414L12%2022.414l-8.707-8.707%201.414-1.414z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  down as default
};
//# sourceMappingURL=down.svg.es.js.map
